export class AppSettings {
  isDarkMode?: boolean;
  isLiveData?: boolean;
}
